module.exports = __webpack_public_path__ + "img/turntable.cc7620eb.png";